import { render, staticRenderFns } from "./SocialPostInfo.vue?vue&type=template&id=8736ddb0&"
import script from "./SocialPostInfo.vue?vue&type=script&lang=js&"
export * from "./SocialPostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8736ddb0')) {
      api.createRecord('8736ddb0', component.options)
    } else {
      api.reload('8736ddb0', component.options)
    }
    module.hot.accept("./SocialPostInfo.vue?vue&type=template&id=8736ddb0&", function () {
      api.rerender('8736ddb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostInfo.vue"
export default component.exports